import type { MouseEvent, KeyboardEvent } from 'react';
import utils from '../../../utils';
import Icon, { type IconClassName } from '../../generic/Icon';
import Flex from '../../generic/Flex';
import styles from '../generic/SummaryActionOption.module.less';

type ProjectSummaryActionButtonProps = {
  text: string;
  icon: IconClassName;
  iconHasSpin?: boolean;
  onAction: (event: MouseEvent | KeyboardEvent) => void;
};

const ProjectSummaryActionButton = ({ text, icon, iconHasSpin = false, onAction }: ProjectSummaryActionButtonProps) => (
  <div className={styles.container}>
    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
    <a
      onKeyPress={utils.onEnter(onAction)}
      onClick={onAction}
      role="button"
      tabIndex={0}
    >
      <Flex justify="flex-start" gap={6}>
        <div className={styles.iconContainer}>
          <Icon icon={icon} hasSpin={iconHasSpin} />
        </div>
        <div>{text}</div>
      </Flex>
    </a>
  </div>
);

export default ProjectSummaryActionButton;
